import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ShippingMethod } from '@app/pages/checkout-app/types';

@Component({
  selector: 'delivery-promise-deliverytime-settings',
  standalone: false,
  templateUrl: './delivery-promise-deliverytime-settings.component.html',
  styleUrl: './delivery-promise-deliverytime-settings.component.scss',
})
export class DeliveryPromiseDeliveryTimeSettingsComponent {
  @Input() formGroup: UntypedFormGroup;
  @Input() runningABTest: boolean;
  @Input() deliveryPromiseInputPlaceholder: string;
  @Input() shippingMethodCategory: ShippingMethod;
  @Input() estimatedTimeConversions: string;
  @Input() deliveryPromiseDisplayTimePlaceholder: string;

  readonly ShippingMethod = ShippingMethod;

  constructor() {}

  getDeliveryPromiseInputPlaceholder(): string {
    switch (this.shippingMethodCategory) {
      case ShippingMethod.LOCAL:
        return 'Enter min # of hours';
      default:
        return 'Enter min # of days (0 for same day)';
    }
  }

  getDeliveryPromiseDisplayTimeString(): string {
    switch (this.shippingMethodCategory) {
      case ShippingMethod.LOCAL:
        return 'hours';
      default:
        return 'days';
    }
  }
}
